// extracted by mini-css-extract-plugin
module.exports = {"uploader":"ShopForm_uploader__eM-dy","uploaderField":"ShopForm_uploaderField__8_KB7","buttons":"ShopForm_buttons__3hIfF"};